export default __webpack_public_path__ + "static/personaje1x2-fef78e4ca78ab27acea94f00c8138277.png";